import { render } from "./GatewayReconfigureModal.vue?vue&type=template&id=1c87c246"
import script from "./GatewayReconfigureModal.vue?vue&type=script&lang=js"
export * from "./GatewayReconfigureModal.vue?vue&type=script&lang=js"
script.render = render

export default script